// extracted by mini-css-extract-plugin
export var productImage = "product-list-module--productImage--tKB-Y";
export var productImageWrap = "product-list-module--productImageWrap--227Ow";
export var productInfo = "product-list-module--productInfo--TtNlF";
export var productLink = "product-list-module--productLink--VSmGP";
export var productList = "product-list-module--productList--b9GKT";
export var productListItem = "product-list-module--productListItem--deVNK";
export var productListItemContent = "product-list-module--productListItemContent--qJUpm";
export var productPrice = "product-list-module--productPrice--8Ej+X";